export default "__VITE_PUBLIC_ASSET__759c4fc4__"